import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCompetitionReq } from "../../apis/competition";

export const competition = createAsyncThunk(
  "competition/fetchCompetition",
  async (idToken, { rejectWithValue }) => {
    try {
      const response = await getCompetitionReq(idToken);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

const initialState = {
  isLoading: false,
  isError: false,
  data: [],
  error: null,
};

const competitionSlice = createSlice({
  name: "competition",
  initialState,
  reducers: {
    resetCompetition: (state) => {
      state.data = [];
      state.isLoading = false;
      state.isError = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(competition.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(competition.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(competition.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.payload || "Failed to fetch competition";
      });
  },
});

// Export the async thunk and reducers
export const { resetCompetition } = competitionSlice.actions;
export default competitionSlice.reducer;
